import { Skeleton, SystemIcon } from '@volvo/vcdk-react';
import React from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type Props = {
  isLoading?: boolean;
  size?: number;
  url?: string | null;
  showPlaceholder?: boolean;
};

const UserMetadataAvatar: React.FC<Props> = ({ isLoading = false, size = 120, url, showPlaceholder = false }) => {
  return (
    <div
      className="bg-variant aspect-1-1 flex items-center justify-center overflow-hidden rounded-full"
      style={{
        width: size,
        height: size,
        maxWidth: size,
        minWidth: size,
      }}
    >
      {isLoading ? (
        <Skeleton variant="ellipse" width={size} height={size} />
      ) : url ? (
        <img src={url} alt="User Avatar" className="h-full w-full rounded-full object-cover" />
      ) : showPlaceholder ? (
        <SystemIcon icon="user" size={size / 1.8} />
      ) : null}
    </div>
  );
};

export default withComponentErrorBoundary(UserMetadataAvatar);
